// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.del[data-v-55b43cc2] {\n  background: #f5bfbf;\n  text-decoration: line-through;\n}\n.ins[data-v-55b43cc2] {\n  background: #a2e9b4;\n}\n", ""]);
// Exports
module.exports = exports;
